import React, { useState } from 'react';
import { creditAppsTableColumns } from 'modules/customers/constants';
import { FormInput } from 'components/form';
import { MUITable } from 'components/shared/MUITable';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import makeStyles from '@mui/styles/makeStyles';
import { Box, InputAdornment } from '@mui/material';
import { CreditAppTableRow } from 'modules/customers/types';
import { Search } from '@mui/icons-material';
import { filterTableBySerachTerm } from 'modules/customers/lib';

interface Props {
  creditAppsTableData: CreditAppTableRow[];
}

export const CreditAppsCard = ({ creditAppsTableData }: Props) => {
  const classes = useStyles();

  const [searchValue, setSearchValue] = useState<string>();
  const [tableDataToShow, setTableDataToShow] = useState(creditAppsTableData);

  const handleSearchTermChange = (searchValue: string) => {
    setSearchValue(searchValue);
    if (!searchValue || searchValue.length < 3) {
      return setTableDataToShow(creditAppsTableData);
    }
    const keysToFilter = ['signedBy', 'salesRep', 'location', 'equipment', 'applyingFor'];
    const filteredData = filterTableBySerachTerm(creditAppsTableData, searchValue, keysToFilter);
    setTableDataToShow(filteredData);
  };

  return (
    <CardContainer title="Credit Applications">
      <FormInput
        label="Search"
        variant="outlined"
        value={searchValue}
        sx={{ maxWidth: '50%' }}
        onChange={handleSearchTermChange}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          },
        }}
      />
      <Box className={classes.table}>
        <MUITable<CreditAppTableRow> columns={creditAppsTableColumns} tableData={tableDataToShow} isLoading={false} />
      </Box>
    </CardContainer>
  );
};

const useStyles = makeStyles({
  table: {},
});
